import { CurrencyType } from '@model/WalletDto'

import { useConversionRate } from './useConversionRatesStore'
import { useCurrentPriceForTrade } from './useCurrentPricesStore'
import type { PortfolioTrade } from './useDxtradePortfolioTrades'
import { usePnLCalculation } from './usePnLCalculation'

export function useTradePnl(trade: PortfolioTrade, accountCurrency?: CurrencyType): number | null {
  const live = useCurrentPriceForTrade(trade.symbol, trade.side, 'position')
  const { rate } = useConversionRate(trade.instrumentCurrency, accountCurrency)

  return usePnLCalculation({
    position: trade,
    currentPrice: live ?? null,
    accountCurrency,
    instrumentCurrency: trade.instrumentCurrency,
    conversionRate: rate,
  })
}
